import React from "react";
import PropTypes from "prop-types";

export const STEPS = [
  { key: "details", label: "Series Details", icon: "fal fa-file-alt", legacy: true },
  { key: "schedule", label: "Schedule", icon: "fal fa-calendar" },
  { key: "tickets", label: "Ticket Config", icon: "fal fa-ticket" },
  { key: "automations", label: "Automations", icon: "fal fa-bolt", marketing: true },
  { key: "display", label: "Display", icon: "fal fa-desktop", legacy: true },
  { key: "review", label: "Review", icon: "fal fa-check-circle" },
];

const unavailableTitle = (step, enabled, canAccessMarketing, published) => {
  if (!enabled && !step.legacy && published) return "This series is published, so this step is locked. Change single dates from the events table.";
  if (!enabled && !step.legacy) return `${step.label} is only available for series built with the setup wizard`;
  if (step.marketing && !canAccessMarketing) return `${step.label} requires Marketing access`;
  return undefined;
};

const SeriesSetupNav = ({ active, completion, enabled, settingsEnabled, canAccessMarketing, onSelect, published = false, legacyOnly = false }) => (
  <nav className="series-setup-nav" aria-label="Series setup steps">
    <div className="series-setup-nav-title">Series Setup</div>
    <ul className="series-setup-nav-list">
      {(legacyOnly ? STEPS.filter((step) => step.legacy) : STEPS).map((step) => {
        const isActive = step.key === active;
        const state = enabled ? completion[step.key] : null;
        const title = unavailableTitle(step, enabled, canAccessMarketing, published);
        return (
          <li key={step.key}>
            <button
              type="button"
              disabled={!!title}
              title={title}
              aria-current={isActive ? "step" : undefined}
              className={["series-setup-nav-item", isActive ? "active" : ""].filter(Boolean).join(" ")}
              onClick={() => onSelect(step.key)}
            >
              <i className={step.icon} aria-hidden="true" />
              <span className="series-setup-nav-label">{step.label}</span>
              {state === "complete" && (
                <i className="fas fa-check-circle series-setup-nav-check" aria-label="Complete" />
              )}
              {state === "incomplete" && <span className="series-setup-nav-dot" aria-label="Incomplete" />}
            </button>
          </li>
        );
      })}
    </ul>
    {enabled && settingsEnabled && (
      <button
        type="button"
        aria-current={active === "settings" ? "step" : undefined}
        className={["series-setup-nav-item", "series-setup-nav-settings", active === "settings" ? "active" : ""].filter(Boolean).join(" ")}
        onClick={() => onSelect("settings")}
      >
        <i className="fal fa-cog" aria-hidden="true" />
        <span className="series-setup-nav-label">Settings</span>
        <i className="fal fa-chevron-right" aria-hidden="true" />
      </button>
    )}
  </nav>
);

SeriesSetupNav.propTypes = {
  active: PropTypes.string.isRequired,
  completion: PropTypes.object.isRequired,
  enabled: PropTypes.bool.isRequired,
  settingsEnabled: PropTypes.bool,
  canAccessMarketing: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
  published: PropTypes.bool,
  legacyOnly: PropTypes.bool,
};

export default SeriesSetupNav;
